module.exports = __webpack_public_path__ + "svg/SourceSansPro-Regular.svg?5095acfe87f2b6cc74ab96583646889d";